/**
 * @param authId (required)
 * @param baseUrl (required)
 * @param forceRefreshOfCachedData (optional)
 * @param logger (optional)
 * @param options (optional)
 * @param secret (required)
 * @param stdParameters (optional)
 * @param verboseResponseKeys (optional)
 * -- This should be used by developers to check that the API responses contain the key: value pairs expected
 */
export interface  IPulseRequestConfiguration {
    authId: string;
    baseUrl: string;
    forceRefreshOfCachedData?: boolean;
    logger?: any;
    options?: any;
    secret: string;
    stdParameters?: Record<string, any> | string;
    verboseResponseKeys?: boolean;
}

export class PulseRequestConfiguration implements IPulseRequestConfiguration {
    authId: string;
    baseUrl: string;
    forceRefreshOfCachedData: boolean;
    logger: any;
    options: any;
    secret: string;
    stdParameters: any;
    verboseResponseKeys: boolean;

    /**
     * This implementation of 
     * @param authId (required)
     * @param baseUrl (required)
     * @param forceRefreshOfCachedData (optional - defaults to false)
     * @param logger (optional - defaults to null)
     * @param options (optional - defaults to {})
     * @param secret (required)
     * @param stdParameters (optional - defaults to {})
     * @param verboseResponseKeys (optional - defaults to false) 
     * -- This should be used by developers to check that the API responses contain the key: value pairs expected
     */
    constructor({
        authId,
        baseUrl,
        forceRefreshOfCachedData,
        logger,
        options,
        secret,
        stdParameters,
        verboseResponseKeys,
    }: IPulseRequestConfiguration) {
        this.authId = authId;
        this.baseUrl = baseUrl;
        this.forceRefreshOfCachedData = forceRefreshOfCachedData ?? false;
        this.logger = logger ?? null;
        this.options = options ?? {};
        this.secret = secret;
        this.stdParameters = stdParameters ?? {};
        this.verboseResponseKeys = verboseResponseKeys ?? false;
        
        if (!authId) { throw  new Error('authId is a required property for a pulse request configuration object'); }
        if (!baseUrl) { throw new Error('baseUrl is a required property for a pulse request configuration object'); }
        if ((!secret)) { throw new Error('secret is a required property for a pulse request configuration object');}
    }
}
